import { useState } from "react";
import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { HorizontalDivider } from "@features/Subscription/components/styles";
import { StartEmailSubscription } from "../StartEmailSubscription";
import { GoogleSsoButton } from "@shared/components/GoogleSsoButton";

const Title = styled(Typography)`
  ${(p) => p.theme.media.mobileDown} {
    font-size: 1.75rem;
    line-height: 1.15;
  }
`;

type Props = {
  planId: string;
  planName: string;
};

export const StartIndividualSubscription = ({ planId, planName }: Props) => {
  const [isEmailSent, setIsEmailSent] = useState(false);

  return (
    <div>
      {!isEmailSent && (
        <>
          <Title variant="h4" mb={3}>
            Create your account
          </Title>
          <GoogleSsoButton
            flow="subscription"
            buttonText="Continue with Google"
            variant="outlined"
            fullWidth
          />
          <HorizontalDivider>
            <Typography variant="body2">OR</Typography>
          </HorizontalDivider>
        </>
      )}
      <StartEmailSubscription
        planId={planId}
        planName={planName}
        onEmailSent={() => setIsEmailSent(true)}
      />
      <Typography textAlign="center" mt={6}>
        Already have an account? <Link to="/login">Sign In</Link>
      </Typography>
    </div>
  );
};
